import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=78c23f3a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=78c23f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c23f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c23f3a')) {
      api.createRecord('78c23f3a', component.options)
    } else {
      api.reload('78c23f3a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=78c23f3a&scoped=true&", function () {
      api.rerender('78c23f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QYecxdWde148/JS/comp/PopupBox.vue"
export default component.exports